/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ActivityReportStatusResource = {
    Empty: 'EMPTY',
    Draft: 'DRAFT',
    SubmittedToClient: 'SUBMITTED_TO_CLIENT',
    ValidatedByClient: 'VALIDATED_BY_CLIENT',
    Cancelled: 'CANCELLED'
} as const;
export type ActivityReportStatusResource = typeof ActivityReportStatusResource[keyof typeof ActivityReportStatusResource];


export function instanceOfActivityReportStatusResource(value: any): boolean {
    for (const key in ActivityReportStatusResource) {
        if (Object.prototype.hasOwnProperty.call(ActivityReportStatusResource, key)) {
            // @ts-ignore
            if (ActivityReportStatusResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActivityReportStatusResourceFromJSON(json: any): ActivityReportStatusResource {
    return ActivityReportStatusResourceFromJSONTyped(json, false);
}

export function ActivityReportStatusResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityReportStatusResource {
    return json as ActivityReportStatusResource;
}

export function ActivityReportStatusResourceToJSON(value?: ActivityReportStatusResource | null): any {
    return value as any;
}

